import type { ContentAttachment } from './valueObjects/contentAttachment';
import type { ContentImage } from './valueObjects/contentImage';
import type { ContentS3Path } from './valueObjects/contentS3Path';
import type { ContentText } from './valueObjects/contentText';

import { EntityPvt } from '@/domain/entityPvt';
import { EntityNamePvt } from '@/types/common/entityPvt';

/**
 * コンテンツプロパティ
 */
export type ContentProps = {
  /** S3パス */
  s3Path: ContentS3Path,
  /** テキスト */
  text: ContentText,
  /** 画像リスト */
  images: ContentImage[],
  /** 添付リスト */
  attachments: ContentAttachment[],
}

/**
 * コンテンツJSON
 */
export type ContentJson = {
  /** S3パス */
  s3Path: string,
  /** テキスト */
  text: string,
  /** 画像リスト */
  images: string[],
  /** 添付リスト */
  attachments: {
    /** 名前 */
    name: string,
    /** コンテント */
    content: string,
  }[],
}

/**
 * コンテンツEntity
 */
export class ContentEntity extends EntityPvt<
  ContentProps,
  ContentJson
> {
  toJsonData(): ContentJson {
    const images = [];
    for (let i = 0; i < this.images.length; i += 1) {
      images.push(this.images[i].value);
    }
    const attachments = [];
    for (let i = 0; i < this.attachments.length; i += 1) {
      attachments.push({
        name: this.attachments[i].name,
        content: this.attachments[i].content,
      });
    }
    return {
      s3Path: this.s3Path.value,
      text: this.text.value,
      images,
      attachments,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityNamePvt {
    return EntityNamePvt.WagakoAppNewsContentEntity;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return this.s3Path.value;
  }

  /**
   * S3パス
   */
  get s3Path(): ContentS3Path {
    return this._value.s3Path;
  }

  /**
   * S3パス
   */
  set s3Path(s3Path: ContentS3Path) {
    this._value.s3Path = s3Path;
  }

  /**
   * テキスト
   */
  get text(): ContentText {
    return this._value.text;
  }

  /**
   * テキスト
   */
  set text(text: ContentText) {
    this._value.text = text;
  }

  /**
   * 画像リスト
   */
  get images(): ContentImage[] {
    return this._value.images;
  }

  /**
   * 画像リスト
   */
  set images(images: ContentImage[]) {
    this._value.images = images;
  }

  /**
   * 添付
   */
  get attachments(): ContentAttachment[] {
    return this._value.attachments;
  }

  /**
   * 添付
   */
  set attachments(attachments: ContentAttachment[]) {
    this._value.attachments = attachments;
  }
}
